import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
//
import Iconify from 'src/components/iconify';
import samsaraLogo from 'src/assets/icons/samsara-logo.png';
import motiveLogo from 'src/assets/icons/motive-logo.png';
import sparkleLogo from 'src/assets/icons/sparkle-logo.png';
import ctTruck from 'src/assets/icons/ct-truck.png';

// ----------------------------------------------------------------------

const FUEL_ICONS: Record<string, string> = {
  efs: 'solar:card-bold',
  tch: 'solar:card-2-bold',
  comdata: 'solar:card-recive-bold',
  fleet_one: 'solar:gas-station-bold',
};

export function SourceMark({ source }: { source: string }) {
  const markSx = { height: 34, width: 'auto', mx: 'auto', mb: 1.5, display: 'block' } as const;

  switch (source) {
    case 'samsara':
      return <Box component="img" src={samsaraLogo} alt="Samsara" sx={markSx} />;
    case 'motive':
      return (
        <Box
          component="img"
          src={motiveLogo}
          alt="Motive"
          sx={{ ...markSx, height: 22, my: '14px' }}
        />
      );
    case 'counting_trucks':
      return (
        <Box
          sx={{
            mx: 'auto',
            mb: 1.5,
            width: 50,
            height: 50,
            borderRadius: 1.5,
            bgcolor: '#39423C',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            component="img"
            src={ctTruck}
            alt="Counting Trucks"
            sx={{ height: 26, width: 'auto' }}
          />
        </Box>
      );
    // case 'ai_eld':
    //   return (
    //     <Box
    //       sx={{
    //         mx: 'auto',
    //         mb: 1.5,
    //         width: 50,
    //         height: 50,
    //         borderRadius: 1.5,
    //         bgcolor: '#39423C',
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //       }}
    //     >
    //       <Box component="img" src={ctTruck} alt="AI ELD" sx={{ height: 26, width: 'auto' }} />
    //     </Box>
    //   );
    // case 'sparkle':
    //   return <Box component="img" src={sparkleLogo} alt="Sparkle" sx={{ ...markSx, height: 40, mb: 1 }} />;
    default:
      return (
        <Iconify
          icon={FUEL_ICONS[source] || 'solar:document-add-bold'}
          width={34}
          sx={{ mb: 1.5, color: 'text.secondary' }}
        />
      );
  }
}

// ----------------------------------------------------------------------

type Props = {
  options: { value: string; label: string }[];
  value: string;
  onSelect: (value: string) => void;
  columns?: { xs: number; sm: number };
};

// The big provider cards used on the Miles Source step and in the upload
// dialogs — one look for every "which integration" question.
export default function SourcePicker({
  options,
  value,
  onSelect,
  columns = { xs: 6, sm: 4 },
}: Props) {
  return (
    <Grid container spacing={2}>
      {options.map((option) => (
        <Grid item xs={columns.xs} sm={columns.sm} key={option.value}>
          <Card
            variant="outlined"
            sx={{
              height: 1,
              borderColor: value === option.value ? 'primary.dark' : 'divider',
              borderWidth: 2,
            }}
          >
            <CardActionArea
              onClick={() => onSelect(option.value)}
              sx={{ p: 2.5, textAlign: 'center', height: 1 }}
              data-testid={`source-${option.value}`}
            >
              <SourceMark source={option.value} />
              <Typography variant="subtitle1">{option.label}</Typography>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
